export default "__VITE_ASSET__dILNw0TT__ 120w, __VITE_ASSET__ZSBqnAsz__ 240w, __VITE_ASSET__gZH4dgsG__ 480w, __VITE_ASSET__h2KZGHEU__ 512w";